import React, { useEffect, useState } from "react";
import login_lft_img from "../../../assets/admin/login_lft_img.webp";
import "../adminStyles.css";
import { Link, useNavigate } from "react-router-dom";
import { LuEye } from "react-icons/lu";
import { LuEyeClosed } from "react-icons/lu";
import ReCAPTCHA from "react-google-recaptcha";
import { env } from "../../../core/service/envconfig";
import AdminHeader from "../Header/AdminHeader";
import { getMethod, postMethod } from "../../../core/service/common.api";
import apiService from "../../../core/service/detail";
import { toast } from "react-hot-toast";
const Login = () => {
  const initialFormValue = {
    email: "",
    password: "",
  };

  const [passHide, setPasshide] = useState(false);
  const [inputType, setinputType] = useState("password");
  const [formValue, setFormValue] = useState(initialFormValue);
  const [emailValidate, setemailValidate, emailValidateref] = useState();
  const [passwordValidate, setpasswordValidate, passwordValidateref] =
    useState();
  const [captchvalue, setcaptchvalue, captchvalueref] = useState("");
  const [captchaError, setCaptchaError, captchaErrorref] = useState(false);
  const [validationnErr, setvalidationnErr] = useState("");
  const [loader, setloader] = useState(false);
  const { email, password } = formValue;
  const [loginCheck, setLoginCheck] = useState(
    localStorage.getItem("loginCheck")
  );
  console.log(loginCheck, "loginCheck");
  const navigaiton = useNavigate();
  useEffect(() => {
    const getToken = localStorage.getItem("user_token");
    if (getToken) {
      navigaiton("/admin/dashboard");
    }
  }, [0]);
  //Toast function
  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(message);
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  const passwordHide = (data) => {
    if (data == "hide") {
      setPasshide(true);
      setinputType("text");
    } else {
      setPasshide(false);
      setinputType("password");
    }
  };

  const onChangeRecaptcha = (value) => {
    var captcha = value;
    if (captcha) {
      setcaptchvalue(captcha);
      setCaptchaError(false);
    } else {
      setcaptchvalue("");
      setCaptchaError(true);
    }
    console.log("captcha value:", value);
  };

  const validate = async (values) => {
    const errors = {};

    if (!values.email) {
      errors.email = "Email is a required field!";
      setemailValidate(true);
    } else if (
      !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address!";
      setemailValidate(true);
    } else {
      setemailValidate(false);
    }

    if (!values.password) {
      setpasswordValidate(true);
      errors.password = "Password is required!";
    } else if (values.password.length < 8 || values.password.length > 30) {
      setpasswordValidate(true);
      errors.password = "Password should be between 8 and 30 characters!";
    } else if (!values.password.match(/[a-z]/)) {
      setpasswordValidate(true);
      errors.password = "Please enter at least one lowercase character!";
    } else if (!values.password.match(/[A-Z]/)) {
      setpasswordValidate(true);
      errors.password = "Please enter at least one uppercase character!";
    } else if (!values.password.match(/[0-9]/)) {
      setpasswordValidate(true);
      errors.password = "Please enter at least one digit!";
    } else if (!values.password.match(/[!@#$%^&*]/)) {
      setpasswordValidate(true);
      errors.password = "Please enter at least one special character!";
    } else {
      delete errors.password;
      setpasswordValidate(false);
    }

    setvalidationnErr(errors);
    return errors;
  };
  const handleClick = async (e) => {
    try {
      e.preventDefault();
      validate(formValue);

      if (captchvalue == "") {
        console.log("sdc");

        setCaptchaError(true);
        return;
      }
      if (
        emailValidate === false &&
        passwordValidate === false &&
        captchaError === false
      ) {
        var loginObj = {
          email: formValue.email,
          password: formValue.password,
        };
        setloader(true);
        var data = {
          apiUrl: apiService.loginAdmin,
          payload: loginObj,
        };
        var resp = await postMethod(data);
        setloader(false);
        console.log(resp);
        if (resp.status == true) {
          showsuccessToast(resp.message);
          localStorage.setItem("userEmail", formValue.email);
          localStorage.setItem("loginCheck", true);
          localStorage.setItem("user_token", resp.token);
          // navigaiton("/admin/dashboard");
          window.location.href = "/admin/dashboard";
        } else {
          showerrorToast(resp.message);
        }
      } else {
        validate(formValue);
      }
    } catch (err) {
      console.log(err, "=======login submit error=====");
    }
  };

  return (
    <>
      <AdminHeader />
      <main className="main_flx auth_main_flx">
        <div className="auth_main_wrp login_main_wrp">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 auth-left-col">
              <div className="login_lft_img">
                <img src={login_lft_img} alt="login_lft_img" />
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 auth-right-col">
              <div className="auth-right-side">
                <h5>
                  Welcome back to <br /> Assetly !
                </h5>

                <form className="auth-Form">
                  <div className="authInputGrp">
                    <label>Email</label>
                    <input
                      type="text"
                      name="email"
                      placeholder="Enter email"
                      autocomplete="off"
                      value={email}
                      onChange={(e) => {
                        const { value } = e.target;
                        const sanitizedValue = value.replace(/\s/g, "");
                        setFormValue((prev) => ({
                          ...prev,
                          email: sanitizedValue,
                        }));

                        if (!sanitizedValue) {
                          setvalidationnErr((prev) => ({
                            ...prev,
                            email: "Email is a required field!",
                          }));
                          setemailValidate(true);
                        } else if (
                          !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
                            sanitizedValue
                          )
                        ) {
                          setvalidationnErr((prev) => ({
                            ...prev,
                            email: "Invalid email address!",
                          }));
                          setemailValidate(true);
                        } else {
                          setvalidationnErr((prev) => {
                            const { email, ...rest } = prev;
                            return rest;
                          });
                          setemailValidate(false);
                        }
                      }}
                    />
                    {validationnErr && validationnErr.email && (
                      <p className="errorcss">{validationnErr.email}</p>
                    )}
                  </div>
                  <div className="authInputGrp">
                    <label>Password</label>
                    <div className="passwrd_input_main">
                      <input
                        type={inputType}
                        name="password"
                        autocomplete="off"
                        value={password}
                        placeholder="Enter password"
                        maxLength={30}
                        onChange={(e) => {
                          const { value } = e.target;
                          const sanitizedValue = value.replace(/\s/g, "");
                          setFormValue((prev) => ({
                            ...prev,
                            password: sanitizedValue,
                          }));

                          let error = "";

                          if (!sanitizedValue) {
                            error = "Password is required field!";
                          } else if (
                            sanitizedValue.length < 8 ||
                            sanitizedValue.length > 30
                          ) {
                            error =
                              "Password should be between 8 and 30 characters!";
                          } else if (!/[a-z]/.test(sanitizedValue)) {
                            error =
                              "Please enter at least one lowercase character!";
                          } else if (!/[A-Z]/.test(sanitizedValue)) {
                            error =
                              "Please enter at least one uppercase character!";
                          } else if (!/[0-9]/.test(sanitizedValue)) {
                            error = "Please enter at least one digit!";
                          } else if (!/[!@#$%^&*]/.test(sanitizedValue)) {
                            error =
                              "Please enter at least one special character!";
                          }

                          if (error) {
                            setvalidationnErr((prev) => ({
                              ...prev,
                              password: error,
                            }));
                            setpasswordValidate(true);
                          } else {
                            setvalidationnErr((prev) => {
                              const { password, ...rest } = prev;
                              return rest;
                            });
                            setpasswordValidate(false);
                          }
                        }}
                      />
                      {passHide == true ? (
                        <span
                          className="auth_eye_icon"
                          onClick={() => passwordHide("show")}
                        >
                          <LuEye />
                        </span>
                      ) : (
                        <span
                          className="auth_eye_icon"
                          onClick={() => passwordHide("hide")}
                        >
                          {/* <LuEye /> */}

                          <LuEyeClosed />
                        </span>
                      )}
                    </div>
                    {validationnErr && validationnErr.password && (
                      <p className="errorcss">{validationnErr.password}</p>
                    )}
                  </div>
                  {/* <Link className="frgt-psswd_auth" to={""}>
                    Forget Password ?
                  </Link> */}
                  <div className="captcha_wrp">
                    <div className="recaptcha_wrapper">
                      <ReCAPTCHA
                        sitekey={env.RECAPTCHA_KEY}
                        onChange={onChangeRecaptcha}
                        // theme={theme === "dark" ? "dark" : "light"}
                        theme="light"
                        size="normal"
                        className="captcha_main"
                      />
                    </div>
                    {captchaError == true && (
                      <p className="errorcss mt-3">
                        Verify you are not a robot!
                      </p>
                    )}
                  </div>
                  {loader == true ? (
                    <button className="auth_submit_btn">Loading...</button>
                  ) : (
                    <button className="auth_submit_btn" onClick={handleClick}>
                      Sign In
                    </button>
                  )}
                </form>

                {/* <div className="auth_footer">
                  Don’t have an account?<span>Sign Up</span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Login;
